import { render, staticRenderFns } from "./FailedJob.vue?vue&type=template&id=2ef61cbe&scoped=true"
import script from "./FailedJob.vue?vue&type=script&lang=ts"
export * from "./FailedJob.vue?vue&type=script&lang=ts"
import style0 from "./FailedJob.vue?vue&type=style&index=0&id=2ef61cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef61cbe",
  null
  
)

export default component.exports